<template>
    <div style="width: 100%">
        <v-card elevation="6">
            <div class="d-flex flex-row">
                <v-card-title
                    class="d-flex grow"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <h3 class="ma-0 font-weight-light">
                        Seguimiento Gestiones
                    </h3>
                </v-card-title>
            </div>
            <v-divider class="test mb-2"></v-divider>
            <v-card flat>
                <div style="width: 100%">
                    <div class="px-2">
                        <v-text-field
                            class="px-2"
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="gestiones"
                        :footer-props="footersProps"
                        :page.sync="page"
                        :items-per-page="10"
                        :options.sync="options"
                        :server-items-length="totalEntries"
                        class="elevation-0 px-2"
                        :loading="loading"
                        :hide-default-footer="loading"
                    >
                        <template v-slot:item.cliente.nombre="{ item }">
                            <div class="font-weight-medium">
                                {{
                                    item.cliente.nombre
                                        ? item.cliente.nombre
                                        : 'Sin asignar'
                                }}
                            </div>
                        </template>
                        <template
                            v-if="$store.getters['login/hasManagerPermission']"
                            v-slot:item.comercial="{ item }"
                        >
                            <div>
                                {{ getNombreComercial(item) }}
                            </div>
                        </template>
                        <template v-slot:item.fechaContacto="{ item }">
                            <div class="font-italic">
                                {{ formatDate(item.fechaContacto) }}
                            </div>
                        </template>
                        <template v-slot:item.updatedOn="{ item }">
                            <div class="font-italic">
                                {{ formatDate(item.updatedOn) }}
                            </div>
                        </template>
                        <template v-slot:item.showGestion="{ item }">
                            <v-btn
                                color="#2c3a5c"
                                :disabled="loading"
                                @click="viewGestion(item)"
                                icon
                            >
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.actions_fecha="{ item }">
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-icon
                                        color="primary"
                                        :disabled="loading"
                                        @click="changeDateAtencion(item)"
                                        loading
                                    >
                                        mdi-calendar
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.actions_eliminar="{ item }">
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <v-icon
                                        color="red"
                                        :disabled="loading"
                                        @click="toggleDeleteForm(item)"
                                        loading
                                    >
                                        mdi-delete
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-card>
        <AdministrationForm />
        <v-dialog
            transition="dialog-top-transition"
            max-width="700"
            v-model="isOpenDeleteDialog"
        >
            <v-card class="pa-md-6">
                <div class="d-flex justify-space-between px-4">
                    <h1 class="px-3 font-weight-light black--text text-center">
                        ¿Está seguro de que quiere borrar esta gestion?
                    </h1>
                    <v-icon size="90" color="orange"> mdi-alert </v-icon>
                </div>
                <div class="pt-4">
                    <p class="px-6 font-weight-light black--text text-center">
                        <v-icon color="red">mdi-delete</v-icon>
                        Recuerde proceder con cautela, este cambio podría ser
                        irreversible y afectar a la consistencia en los datos ya
                        existentes en la base de datos. Consulte con los
                        administradores si no está seguro de lo que está
                        haciendo.
                    </p>
                </div>

                <v-card-actions class="justify-end mb-md-n6 mr-md-n8">
                    <v-btn text color="red" @click="toggleDeleteForm()">
                        Cerrar
                        <!-- <v-icon> mdi-location-exit </v-icon> -->
                    </v-btn>
                    <v-btn dark color="red" @click="deleteAtencion()">
                        Borrar
                        <!-- <v-icon> mdi-delete-outline </v-icon> -->
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
    
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import AdministrationForm from '../../ComercialTeletrabajo/TtForm/AdministrationForm.vue';
import FormAtencion from '@/components/AreaPersonal/Calculadora/FormAtencion.vue';

export default {
    name: 'TablaGestiones',
    components: {
        AdministrationForm,
        FormAtencion,
    },
    data: () => ({
        headers: [
            { text: 'Cliente', value: 'cliente.nombre', sortable: false },
            {
                text: 'Fecha contacto',
                value: 'fechaContacto',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Actualizado',
                value: 'updatedOn',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Gestión',
                value: 'servicio.name',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Ver gestión',
                value: 'showGestion',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Cambiar fecha',
                value: 'actions_fecha',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Eliminar',
                value: 'actions_eliminar',
                align: 'center',
                sortable: false,
            },
        ],
        footersProps: {
            disableItemsPerPage: false,
            itemsPerPageOptions: [10],
        },
        gestiones: [],
        options: {},
        selectedAtencion: null,
        page: 1,
        totalEntries: 0,
        loading: false,
        isOpenViewDialog: false,
        search: null,
        isOpenDeleteDialog: false,
    }),
    props: {
        currentDate: Date,
    },
    computed: {
        ...mapState('areaPersonal/calculadora', {
            selectedComercial: (state) => state.selectedComercial,
            isAlreadyUpdated: (state) =>
                state.dateAtencionForm.isAlreadyUpdated,
            father: (state) => state.dateAtencionForm.father,
        }),
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
    },
    methods: {
        ...mapActions({
            fetchGestiones: 'areaPersonal/calculadora/fetchGestiones',
        }),
        changeDateAtencion(atencion) {
            this.atencion = JSON.parse(JSON.stringify(atencion));
            let dateAtencionForm = {
                father: 'GESTION',
                isAlreadyUpdated: false,
                isOpen: true,
                isEditing: false,
                isLoading: false,
                form: atencion,
            };

            this.$store.commit(
                'areaPersonal/calculadora/dateAtencion',
                dateAtencionForm
            );
        },
        deleteAtencion() {
            this.selectedAtencion = JSON.parse(
                JSON.stringify(this.selectedAtencion)
            );
            let dateAtencionForm = {
                father: 'GESTION',
                isAlreadyUpdated: false,
                isOpen: false,
                isEditing: false,
                isLoading: false,
                form: this.selectedAtencion,
            };

            this.$store.commit(
                'areaPersonal/calculadora/dateAtencion',
                dateAtencionForm
            );

            this.$store
                .dispatch('areaPersonal/calculadora/deleteAtencion')
                .then(() => {
                    this.update();
                });
            this.toggleDeleteForm();
        },
        toggleDeleteForm(item = null) {
            if (item) this.selectedAtencion = item;
            this.isOpenDeleteDialog = !this.isOpenDeleteDialog;
        },
        formatDate(date) {
            let mondate = new Date(date);
            let options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
                timeZone: 'Europe/Madrid',
            };
            return new Intl.DateTimeFormat('es-ES', options).format(mondate);
        },
        formatHour(date) {
            let mondate = new Date(date);
            let hours =
                mondate.getHours().toString().length > 1
                    ? mondate.getHours()
                    : '0' + mondate.getHours();
            let minutes =
                mondate.getMinutes().toString().length > 1
                    ? mondate.getMinutes()
                    : '0' + mondate.getMinutes();
            let seconds =
                mondate.getSeconds().toString().length > 1
                    ? mondate.getSeconds()
                    : '0' + mondate.getSeconds();

            return `${hours}:${minutes}:${seconds}`;
        },
        viewGestion(atencion) {
            let AdministrationForm = {
                isOpen: true,
                isSaving: false,
                isEditable: false,
                form: { ...atencion, gestion: atencion.servicio },
            };

            this.$store.commit(
                'teletrabajo/AdministrationForm',
                AdministrationForm
            );
        },
        getNombreComercial(item) {
            let nombre = 'Sin asignar';
            if (item.comercial) {
                if (this.comerciales) {
                    let comercial_find = this.comerciales.find(
                        (comercial) => comercial.id === item.comercial.id
                    );
                    if (comercial_find) {
                        nombre = comercial_find.nombreCompleto;
                    }
                }
            }
            return nombre;
        },
        async update() {
            this.loading = !this.loading;
            try {
                let params = {
                    ...{
                        mes_year_updated_on: `${this.currentDate.getFullYear()}-${
                            this.currentDate.getMonth() + 1
                        }`,
                    },
                    ...this.options,
                };

                if ('itemsPerPage' in params) {
                    if (this.hasManagerPermission && this.selectedComercial)
                        params.comercial = this.selectedComercial.id;
                    if (this.search) params.search = this.search;
                    let data = await this.fetchGestiones(params);
                    this.gestiones = data.results;
                    this.totalEntries = data.count;
                }
            } catch (err) {
                console.log(err.message);
            }
            this.loading = !this.loading;
            // setTimeout(() => (this.loading = !this.loading), 200);
        },
    },
    watch: {
        options: {
            immediate: true,
            handler: async function (newVal, oldVal) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                    return;
                }

                this.update();
            },
        },
        selectedComercial() {
            // this.options = {};
            this.page = 1;
            this.update();
        },
        currentDate() {
            this.update();
        },
        search(newVal, oldVal) {
            let prev = newVal;
            setTimeout(() => {
                if (prev == this.search) this.update();
            }, 200);
        },
        isAlreadyUpdated() {
            if (this.father == 'GESTION' && this.isAlreadyUpdated) {
                this.$store.commit(
                    'areaPersonal/calculadora/dateAtencionIsAlreadyUpdated',
                    false
                );
                this.update();
            }
        },
    },
    mounted() {
        if (this.$store.getters['login/hasManagerPermission']) {
            this.headers.splice(1, 0, {
                text: 'Comercial',
                value: 'comercial',
                align: 'center',
            });
        }
    },
};
</script>

<style>
</style>